import { render, staticRenderFns } from "./ItemResultDefault.vue?vue&type=template&id=ec772b36&"
import script from "./ItemResultDefault.vue?vue&type=script&lang=js&"
export * from "./ItemResultDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports